const { general } = require('./_general');
const { Sortable } = require('sortablejs');
//import Sortable from 'sortablejs';


var schedule = {

    listen: function () {

        $("a[data-action='open-add-delivery-modal']").on("click", function(event) {

            schedule.openAddDeliveryModal(event, $(this));
        });

        $("a[data-action='open-edit-delivery-modal']").on("click", function(event) {
            
            schedule.openAddDeliveryModal(event, $(this)); 
        });

        for (var i=1; i<=50; i++) {
            var sort = document.getElementById('sortable_' + i);
            if (!sort) {
                break; 
            }
            var sortable = new Sortable(sort, {
                group: 'shared', // set both lists to same group
                animation: 100,
                onEnd: function(CustomEvent) {

                    var droppedInListEl = $("#"+CustomEvent.to.id);
                    var cardEl = $("#"+CustomEvent.item.id);
                    var droppedInIdx = CustomEvent.newIndex;

                    var data = [
                        {name: "newIndex", value: droppedInIdx},
                        {name: "day", value: droppedInListEl.data("date")},
                        {name: "deliveryId", value: cardEl.data("deliveryid")}
                    ];

                    $.post(droppedInListEl.data("route"), data, function (response) {
                        
                        // Recalculate and update all the utilisation at the tops of all the days
                        schedule.recalcUtilisation();


                    }, "json");
                }
            });

        }

    },


    openAddDeliveryModal: function(event, $element) {
        event.preventDefault();

        var $modal = $("#addDeliveryModal");
        var route = $modal.data("modalurl");
        var forDate = $element.data("fordate");
        
        var deliveryId = $element.data("deliveryid");
        var jobId = $element.data("jobid");
        var mode = $element.data("mode");

        // Check if we're in customer area
        var isCustomerMode = window.location.href.includes('/customer-area/');

        var data = [
            {name: "deliveryId", value: deliveryId},
            {name: "jobId", value: jobId},
            {name: "customerMode", value: isCustomerMode ? '1' : '0'},
            {name: "mode", value: mode},
        ];

        $.post(route, data, function(response) {

            $modal.replaceWith(response.markup);
            $modal = $("#addDeliveryModal"); // Refresh reference since it's been replaced

            // If we've click on "Add" for a date, pre-populate the date in the modal
            if (!deliveryId) {
                $("[name=door_delivery_date]", $modal).val(forDate);
                $("[name=cavity_delivery_date]", $modal).val(forDate);
                $("[name=production_date]", $modal).val(forDate);
                $("[name=cavity_production_date]", $modal).val(forDate);
            }
                        
            var modal = new window.bootstrap.Modal(document.getElementById('addDeliveryModal'), {})
            general.initSelect2($("#addDeliveryModal"));
            modal.show()

        }, "json");
        
    },
    /**
     * On the schedule page, recalculate and update all of the utilisation bars at the top of the schedule page.
     * 
     * @param <string> forDate - MySQL format. We'll figure out the Monday of this week and calculate the utilisation from there
     */
    recalcUtilisation: function(forDate) {
        
        $(".schedule-day").each(function() {
            var dayEl = $(this);
            var dailyLimit = dayEl.data("dailylimit");
            var numDeliveries = $(".delivery-card", dayEl).length;

            var daysProgressBar = $(".progress-bar", dayEl);
            var utilisation = (numDeliveries / dailyLimit) * 100

            daysProgressBar.attr("aria-valuenow", utilisation);
            daysProgressBar.css("width", utilisation+"%");
        })
    }
    


}

$(function () {
    schedule.listen()
});

module.exports = {
    schedule
};